// react imports
import React, { useEffect } from "react"

// package imports
import { Col, Row } from "react-bootstrap"

// project imports
import { NextButton } from "components"
import QmsSolutionStatus from "constants/QmsSolutionStatus"
import qmsDashboardPageStore from "modules/qms-flow/qms-dashboard-page/qms-dashboard-page-store"
import StorageKeys from "constants/StorageKeys"
import AuthStore from "modules/login/store/AuthStore"

import "./proposer-details-card.css"
import setCookie from "utils/journeyIdCookie/setJourneyId"
import QmsStorageKeys from "constants/QmsStorageKeys"
import qmsOldPackageIsList from "constants/qmsOldPackageIsList"
import { observer } from "mobx-react"
import { BANCA_JOURNEY, NEW_QMS_CHANNEL_LIST, SAMS_JOURNEY } from "constants/Constants"
import { toJS } from "mobx"
import getSpDetailsForSamsQms from "utils/getSpDetailsForSamsQms"
import getCookieValue from "utils/getCookieValue/getCookieValue"

function ProposerDetailsCardForNAStatus(props) {
    const { proposerData, solutionData, buttonId, statusId, journeyData, showSingleCard } = props

    let channelName = NEW_QMS_CHANNEL_LIST
    let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];
    let designationCode = localStorage.getItem(QmsStorageKeys.DESIGNATION_CODE)
    let agentName = localStorage.getItem(QmsStorageKeys.AGENT_NAME)
    console.log("solution_dms_id ", journeyData.product_coverage_list)
    let sourceFrom = toJS(AuthStore.sourceFrom)
    let source_system = getCookieValue("source")

    useEffect(() => {

        if (buttonId && solutionData.solution_status) {
            const buttonElement = document.getElementById(buttonId);
            if (buttonElement) {
                buttonElement.style.backgroundColor = solutionData?.button_color;
                buttonElement.style.borderColor = solutionData?.button_color;
                buttonElement.style.color = solutionData?.button_text_color;
            }
        }
        if ((showResumeAnalysisButton(journeyData.product_coverage_list) && solutionData?.solution_status_id === QmsSolutionStatus.QUOTE_SHARED)) {
            document.getElementById(buttonId).style.backgroundColor = "#f76f8b"
            document.getElementById(buttonId).style.borderColor = "#f76f8b"
            document.getElementById(buttonId).style.color = "#333333"
        }

        if (statusId && solutionData.solution_status) {
            const statusElement = document.getElementById(statusId);
            if (statusElement) {
                statusElement.style.color = solutionData?.status_text_color;
            }
        }
    }, [buttonId, statusId, solutionData.solution_status, solutionData?.button_color, solutionData?.button_text_color, solutionData?.status_text_color]);

    const onViewDetailsClick = async () => {
        setCookie("journeyId", journeyData?.journey_id);
        localStorage.setItem(StorageKeys.SOURCE_FROM, "NA")
        let channelCodeList = ["CSB", "COA", "OA"]

        if (channelCodeList.includes(channel_code) || source_system === BANCA_JOURNEY || source_system === SAMS_JOURNEY) {
            await getSpDetailsForSamsQms(journeyData?.journey_id)
        }
        let buttonTextConstant = qmsDashboardPageStore.qmsButtonConstant(solutionData?.button_text)
        await qmsDashboardPageStore.saveQMSUserClicks(buttonTextConstant, journeyData?.journey_id)

        switch (solutionData.solution_status_id) {
            case QmsSolutionStatus.ANALYSIS_IN_PROGRESS:
                let routeName = fetchNARoutes()
                let agentId = localStorage.getItem(StorageKeys.AGENT_ID)
                let token = sessionStorage.getItem(StorageKeys.AUTH_TOKEN)

                localStorage.setItem('directedFromQMS', true);
                localStorage.setItem('routeName', routeName)



                localStorage.setItem('directedFromQMS', true);



                if (routeName) {
                    localStorage.setItem(StorageKeys.LANDING_FROM_QMS, true);
                    localStorage.setItem(StorageKeys.FIRST_TIME_OPTIMIZATION_PAGE_LOAD_PARAM, false);
                    // props.history.push(`/${routeName}/${journeyData.journey_id}?agent_id=${agentId}&token=${token}`) 
                    await AuthStore.fetchAllData(journeyData.journey_id)
                    props.history.push(`/${routeName}`)

                } else {
                    // props.history.push(`/${routeName}?agent_id=${agentId}&token=${token}`)
                    props.history.push(`/${routeName}`)

                }
                break;

            case QmsSolutionStatus.QUOTE_SHARED:
                props.history.push("/qms/qms-details", { proposerId: proposerData?.proposer_id, journeyId: journeyData.journey_id })
                break;
        }
    }
    const fetchNARoutes = () => {
        let route = ""

        switch (journeyData.current_journey_screen) {
            case "choose_need":
                route = "choose-needs"
                break;

            case "family_details":
                route = "family-details"
                break;

            case "customization":
                route = "customization"
                break;
            case "preview-share":
                route = "customization"
                break;
            case "solution":
                route = "solution"
                break;

            case "solution_preview":
                route = "quotation-preview"
                break;

            default:
                break
        }

        return route
    }
    const showResumeAnalysisButton = (productCoverageList) => {

        let oldPackagelist = qmsOldPackageIsList
        let list = productCoverageList
        let allValuesMatch = list?.some(item => oldPackagelist.includes(item?.package_id))

        return allValuesMatch
    }


    const onClickResumeAnalysis = async () => {

        let routeName = "customization"
        setCookie("journeyId", journeyData?.journey_id);

        localStorage.setItem('directedFromQMS', true);
        localStorage.setItem('routeName', routeName)
        localStorage.setItem(StorageKeys.LANDING_FROM_QMS, true);
        localStorage.setItem(StorageKeys.FIRST_TIME_OPTIMIZATION_PAGE_LOAD_PARAM, false);
        // props.history.push(`/${routeName}/${journeyData.journey_id}?agent_id=${agentId}&token=${token}`) 
        await AuthStore.fetchAllData(journeyData.journey_id)
        props.history.push(`/${routeName}`)

    }

    let showResumeAnalysis = showResumeAnalysisButton(journeyData?.product_coverage_list)

    return (
        <>
            <Col md="2" className="card-inner-padding">
                <p className="mb-0 font-size-14 font-weight-medium client-name">{qmsDashboardPageStore.getFamilyMemberName(proposerData, false, journeyData, true)}  {showSingleCard && '(' + proposerData.proposer_member_type + ')'}</p>
                {proposerData?.mobile_number && <a href={`tel:${proposerData?.mobile_number}`} className="font-size-12 font-weight-400 mb-0 mr-1 mobile-number">{proposerData.mobile_number}</a>}
            </Col>

            <div className='d-none d-md-block border-right mx-md-3'></div>
            <div className='d-block d-md-none border-bottom w-100 mx-md-3'></div>

            <Col md="3" className="card-inner-padding border-left">
                <div className="d-flex align-items-center">
                    <p className="mb-0 font-size-10 font-weight-400 subtitle mr-3">Status</p>
                    <div className='py-3 border-right'></div>
                    <div>
                        <p id={statusId} className={`mb-0 font-size-14 font-weight-medium ml-3`}>{solutionData.solution_status || '-'}</p>
                        {solutionData.solution_status_id == QmsSolutionStatus.QUOTE_SHARED && solutionData.solution_id && <p className="mb-0 font-size-10 font-weight-300 subtitle ml-3">Soln ID:{solutionData.solution_id || '-'}</p>}
                        {channelName.includes(channel_code) &&
                            <>
                                <p className="mb-0 font-size-10 font-weight-400 subtitle ml-3 ">Agent Name: {journeyData.agent_name}</p>
                                <p className="mb-0 font-size-10 font-weight-400 subtitle ml-3">Designation: {journeyData.agent_type}</p>
                                <p className="mb-0 font-size-10 font-weight-400 subtitle ml-3">Product Name & Coverage:</p>
                                {journeyData?.product_coverage_list?.map((item) => {
                                    return (
                                        <p className="mb-0 font-size-10 font-weight-400 subtitle ml-4">{item?.product_name} {item?.coverage_percentage}%</p>
                                    )
                                })}

                            </>
                        }
                    </div>
                </div>
            </Col>

            <div className='d-none d-md-block border-right mx-md-3'></div>
            <div className='d-block d-md-none border-bottom w-100 mx-md-3'></div>
            <Col md="6" className="pr-md-1 card-inner-padding">
                <Row>
                    <Col md={"6"} className="pl-md-0">
                        <p className="mb-0 font-size-10 font-weight-400 subtitle">Next Actions</p>
                        <p className="mb-0 font-size-12 font-weight-400 subtitle">{solutionData.next_action_text || '-'}</p>
                        {qmsDashboardPageStore.expiringDatelist[journeyData.journey_id] &&
                            <p className="mb-0 font-size-12 font-weight-700 subtitle text-danger">{`Expiring in ${qmsDashboardPageStore.expiringDatelist[journeyData.journey_id]} Days`}</p>
                        }
                    </Col>

                    {(showResumeAnalysis && solutionData.solution_status_id == QmsSolutionStatus.QUOTE_SHARED) ? (
                        <Col md="6" className="justify-content-md-end d-md-flex mt-4 mt-md-0 px-1">
                            <NextButton
                                id={buttonId}
                                buttonText={'Resume Analysis'}
                                className={`status-btn`}
                                onClick={() => onClickResumeAnalysis()}
                            />
                        </Col>
                    ) : (
                        <>
                            {!channelName.includes(channel_code) ? (
                                <Col md="6" className="justify-content-md-end d-md-flex mt-4 mt-md-0 px-1">
                                    {solutionData.solution_status && (
                                        <NextButton
                                            id={buttonId}
                                            buttonText={solutionData.button_text}
                                            className={`status-btn`}
                                            onClick={() => onViewDetailsClick()}
                                        />
                                    )}
                                </Col>
                            ) : (
                                <>
                                    {journeyData.same_agent && (
                                        <Col md={`${(solutionData?.solution_dms_id && !showResumeAnalysis) ? "3" : "6"}`} className="justify-content-md-end d-md-flex mt-4 mt-md-0 px-1">
                                            <NextButton
                                                id={buttonId}
                                                buttonText={solutionData.button_text}
                                                className={`status-btn`}
                                                onClick={() => onViewDetailsClick()}
                                            />
                                        </Col>
                                    )}
                                    {(solutionData?.solution_dms_id && !showResumeAnalysis) && (
                                        <Col md={`${journeyData.same_agent ? "3" : "6"}`} className="justify-content-md-end d-md-flex mt-2 mt-md-0 px-1">
                                            <NextButton
                                                id={buttonId}
                                                buttonText={sourceFrom === "Distribution_App" ? "View pdf" : "Download pdf"}
                                                className={`status-btn download-pdf-btn`}
                                                onClick={() => qmsDashboardPageStore.fetchPdfUrl(solutionData, proposerData, journeyData?.journey_id, sourceFrom)}
                                            />
                                        </Col>
                                    )}
                                </>
                            )}
                        </>
                    )}

                </Row>
            </Col>
            <div className=' border-bottom w-100 d-none d-md-block'></div>
        </>
    )
}

export default observer(ProposerDetailsCardForNAStatus)
